import * as Moment from "moment"
import * as React from "react"
import { ActivitySummaryProps } from '../../../Shared/components/LegacyProps'
import { slugify } from "../../../Shared/utils/string"
import { getCurrentFilterQuery } from "./filters"
import { Link } from "./library/link"
import { TeaserContent } from "./teaser"

export const ActivitySummary = (p: ActivitySummaryProps ): JSX.Element => (
  p.title == "loading" ? null : (
    <li className="teaser teaser--default teaser--image col-xs-12 col-sm-6 col-md-4">
      <Link
        key={p.route}
        url={`${p.route}${getCurrentFilterQuery()}`}
        className="teaser__link"
        handle={() => p.onClick && p.onClick()}
        aria-labelledby={`a11y-teaser-title-${slugify(p.title)}`}
      >
        <TeaserContent
          headingLevel={p.headingLevel}
          title={p.title}
          isTip={p.isTip}
          imageUrl={p.styleUrls["400x280"]}
          imageUrlLarge={p.styleUrls["800x560"]}
          imageAlt={p.imageAlt}
          label={p.date == "multiple" ? null : (
            <time dateTime={Moment(p.date.getTime() - p.date.getTimezoneOffset() * 60000).format('L')}>
              {Moment(new Date(p.date.getTime() - p.date.getTimezoneOffset() * 60000)).format("L")}
            </time>
          )}
          intro={p.subtitle}
          locationFooter={p.location == "multiple" ? "Meerdere locaties" : p.location}
        />
      </Link>
    </li>
  )
)

{/* TH: Added to styleguide! */}
